import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import SelectStore from "./SelectStore";
import Button from "./Button";
import ActionButton from "./ActionButton";
import TypeSelect from "./typeSelect"
import CheckboxGroup from "./CheckBox";
import OrganizationSelect from "./OrganizationSelect"
import Service from "./service"

const Controls = {
  Input,
  RadioGroup,
  Select,
  Button,
  ActionButton,
  SelectStore,
  TypeSelect,
  CheckboxGroup,
  OrganizationSelect,
  Service
};

export default Controls;
